"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutSessionResponse = exports.CreateCheckoutSessionBody = void 0;
/**
 * SOLID Review
 * S — Strong. One concern: the wire shape of the client-initiated checkout call.
 * O — Strong. A second payment endpoint is an additive schema here.
 * L — N/A.
 * I — Strong: one request, one response.
 * D — Strong: zod only.
 */
/**
 * DDD Layer: none — shared wire contract.
 *
 * SCOPE NOTE. `/api/stripe` holds two endpoints that face opposite directions, and only one of them
 * belongs to this contract:
 *
 *   POST /api/stripe/create-checkout-session   the GAME CLIENT calls it, with a bearer token — HERE
 *   POST /api/stripe/webhooks/stripeforwarding STRIPE'S SERVERS call it, signature-verified — NOT here
 *
 * The webhook is a different seam with a different counterparty, a different auth mechanism (an HMAC
 * over the raw body, not a JWT) and a payload Stripe owns rather than we do. Describing it in the
 * client contract would claim a shape we do not define. It is covered by
 * e2e/scenarios/payment/payment-webhook.spec.ts instead.
 */
const zod_1 = require("zod");
/**
 * Deliberately empty, and `.strict()` so it stays that way.
 *
 * The route takes the player from the bearer token, never the body. The frontend already encoded
 * this as `type ICommandCreateCheckoutSession = Record<string, never>` with a comment explaining
 * that an empty type is not a no-op because excess-property checking still fires. `.strict()` is the
 * runtime half of that same guarantee.
 */
exports.CreateCheckoutSessionBody = zod_1.z.object({}).strict();
exports.CheckoutSessionResponse = zod_1.z.object({
    checkoutUrl: zod_1.z.string(),
    paymentRecordId: zod_1.z.string(),
});
//# sourceMappingURL=payment.js.map